<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    :width="size"
    :height="size"
  >
    <path fill="currentColor" d="M16-0.001c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16v0c-0.010-8.832-7.168-15.99-15.999-16h-0.001zM16 29.999c-7.732 0-14-6.268-14-14s6.268-14 14-14c7.732 0 14 6.268 14 14v0c-0.009 7.728-6.272 13.991-13.999 14h-0.001zM17 10.999h-5v2h3v10h-3v2h8v-2h-3v-12zM14.999 6h2v2.999h-2v-2.999z" />
  </svg>
</template>

<script>
export default {
  name: 'SvgInfo',

  props: {
    size: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>
